import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/images/how-to-develop-content-marketing-strategy.webp")